export const ChatRoundIcon = ({ width = 20, height = 20, fill = '#252525' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_1328_7768)">
      <path d="M10.0007 18.3332C14.603 18.3332 18.334 14.6022 18.334 9.99984C18.334 5.39746 14.603 1.6665 10.0007 1.6665C5.39828 1.6665 1.66732 5.39746 1.66732 9.99984C1.66732 11.3329 1.98033 12.5929 2.53687 13.7102C2.68477 14.0072 2.73399 14.3466 2.64825 14.667L2.15191 16.522C1.93645 17.3273 2.67316 18.064 3.47844 17.8486L5.33347 17.3522C5.65393 17.2665 5.99332 17.3157 6.29026 17.4636C7.40762 18.0202 8.66758 18.3332 10.0007 18.3332Z" stroke={fill} strokeWidth="1.5"/>
      <path d="M6.66602 8.75H13.3327" stroke={fill} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M6.66602 11.6665H11.2493" stroke={fill} strokeWidth="1.5" strokeLinecap="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1328_7768">
        <rect width="20" height="20" fill={fill}/>
      </clipPath>
    </defs>
  </svg>
);
